<div class="wrapper">
  @let code = code$ | async;
  @if (requestStatus.failed) {
    <div role="alert">
      {{ 'DIALOGS.ORDER_CODE.failed' | translate }}
      <button (click)="reload.next()" type="button" mat-button color="primary">{{ 'TABLE.retry' | translate }}</button>
    </div>
  }
  @if (code !== null) {
    <div @show>
      <pre>{{ code }}</pre>
      <app-button-group>
        <button (click)="copyCode(code)" color="primary" mat-stroked-button>
          <mat-icon style="margin-right: 5px;">content_copy</mat-icon>
          <mat-label>{{ 'COMMON.copy' | translate }}</mat-label>
        </button>
      </app-button-group>
    </div>
  }
  @if (requestStatus.loading && code === null) {
    <app-loader @hide [isLocal]="true"></app-loader>
  }

</div>
